const createIntlOptions = ({ selectedChannel, options }) => {
    const numberFormats = {};
    selectedChannel.currencies.forEach(currency => {
        numberFormats[currency.id] = {
            style: 'currency',
            currency: currency.format.code,
            minimumFractionDigits: currency.format.decimals
        };
    });
    return Object.assign({ formats: {
            number: numberFormats
        } }, options);
};
export default createIntlOptions;
//# sourceMappingURL=createIntOptions.js.map